import { render, staticRenderFns } from "./transfer-owner.vue?vue&type=template&id=026e5ed7"
import script from "./transfer-owner.vue?vue&type=script&lang=js"
export * from "./transfer-owner.vue?vue&type=script&lang=js"
import style0 from "./transfer-owner.vue?vue&type=style&index=0&id=026e5ed7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports